import {
  AfterContentChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from "rxjs";
import {
  AdquisicionReactivosViewModel,
  ContratoElectricidadViewModel,
  PagoCombustibleVehiculosViewModel,
  PagoCombustibleViewModel,
  PagoElectricidadViewModel,
  TipoPagoElecOMViewModel,
  TitularFangosViewModel,
  TitularResiduosDesbasteViewModel,
  TitularResiduosNoPeligrososViewModel,
  TitularResiduosPeligrososViewModel,
  TitularidadEnergiaViewModel,
  UbicacionEspanaViewModel,
} from "src/app/_core/models/centros/cebe-contract-list-base.model";
import { CebeContratoViewModel } from "src/app/_core/models/centros/cebe-contract.model";
import { CebeViewModel } from "src/app/_core/models/centros/cebe.model";
import { CebesContractService } from "src/app/_core/providers/cebes-contract.service";
import { CebesService } from "src/app/_core/providers/cebes.service";
import { DecimalService } from "src/app/_core/providers/decimals.service";
import { MasterService } from "src/app/_core/providers/master.service";
import { NotificationService } from "src/app/_core/providers/notification.service";
@Component({
  selector: "app-contract-details-card",
  templateUrl: "./contract-details-card.component.html",
  styleUrls: ["./contract-details-card.component.scss"],
})
export class ContractDetailsCardComponent
  implements OnInit, AfterContentChecked
{
  @Input() contract: CebeContratoViewModel;
  @Input() cebe: CebeViewModel;
  @Output() contractFormComplete = new EventEmitter<boolean>();

  public adquisicionReactivosList: AdquisicionReactivosViewModel[] = [];
  public contratoElectricidadList: ContratoElectricidadViewModel[] = [];
  public pagoCombustibleList: PagoCombustibleViewModel[] = [];
  public pagoCombustibleVehiculosList: PagoCombustibleVehiculosViewModel[] = [];
  public pagoElectricidadList: PagoElectricidadViewModel[] = [];
  public tipoPagoElecOMList: TipoPagoElecOMViewModel[] = [];
  public titularFangosList: TitularFangosViewModel[] = [];
  public titularResiduosDesbasteList: TitularResiduosDesbasteViewModel[] = [];
  public titularResiduosNoPeligrososList: TitularResiduosNoPeligrososViewModel[] =
    [];
  public titularResiduosPeligrososList: TitularResiduosPeligrososViewModel[] =
    [];
  public titularidadEnergiaList: TitularidadEnergiaViewModel[] = [];
  public ubicacionEspanaList: UbicacionEspanaViewModel[] = [];

  myFormContrato: FormGroup;
  countControls: number = 0;
  countFilled: number = 0;

  constructor(
    private readonly _masterService: MasterService,
    private readonly fb: FormBuilder,
    private readonly _cebesContractService: CebesContractService,
    private readonly _cebesService: CebesService,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef,
    private readonly _translateService: TranslateService,
    private readonly _notificationService: NotificationService,
    public decimalService: DecimalService
  ) {}

  // Events
  ngOnInit(): void {
    this._loadData();
    this._loadForm();
  }

  _loadForm() {
    this.myFormContrato = this.fb.group({
      cebeID: [null],
      id: [null],
      cliente: [null],
      contratoInicio: [null],
      contratoFin: [null],
      prorrogaFin: [null],
      participacion: [null, [Validators.max(100), Validators.min(0)]],
      puestaMarcha: [false],
      faseOM: [false],
      pagoElectricidadID: [null],
      contratoElectricidadID: [null],
      titularidadEnergiaID: [null],
      pagoCombustibleID: [null],
      pagoCombustibleVehiculosID: [null],
      puestaMarchaFecha: [null],
      faseOMFecha: [null],
      resPagoElecPmID: [null],
      resPagoElecOmID: [null],
      titularResiduosDesbasteID: [null],
      titularFangosID: [null],
      titularResiduosPeligrososID: [null],
      titularResiduosNoPeligrososID: [null],
      adquisicionReactivosID: [null],
    /*  actividadID: [null],
      tipoProyectoID: [null],*/
      socio: [null],
    });

    this.myFormContrato.patchValue(this.contract);

    this.showTipoProyectoFields();
    this.showPM_OM();
    this.showContratacionSuministroElectrico();

    this._cebesService.cebeActividadValueChanged$.subscribe(() => {
      this.showTipoProyectoFields();
      this.showPM_OM();
      this.showContratacionSuministroElectrico();
    });

    this._cebesService.cebeTipoProyectoValueChanged$.subscribe(() => {
      this.showTipoProyectoFields();
      this.showPM_OM();
      this.showContratacionSuministroElectrico();
    });

    this.myFormContrato
      .get("pagoElectricidadID")
      ?.valueChanges.subscribe((s) => {
        this.showContratacionSuministroElectrico();
      });

    this.myFormContrato.valueChanges.subscribe((formValues) => {
      this.getFormStatus();
    });
  }

  ngAfterContentChecked(): void {
    this.getFormStatus();
  }

  getFormStatus() {
    this.countControls = 0;
    this.countFilled = 0;

    Object.keys(this.myFormContrato.controls).forEach((controlName) => {
      if (controlName !== "cebeID" && controlName !== "id") {
        const control = this.myFormContrato.get(controlName);
        const controlElement = document.querySelector(
          `[formControlName="${controlName}"]`
        );

        if (controlElement) {
          const hasHiddenClass =
            controlElement.parentElement.classList.contains("hidden");

          if (!hasHiddenClass) {
            this.countControls++;

            if (control.value !== null && control.value !== "") {
              this.countFilled++;
            }
          }
        }
      }
    });

    if (this.countFilled !== 0) {
      this.contractFormComplete.emit(this.countControls == this.countFilled);
    }
  }

  private _loadData(): void {
    forkJoin([
      this._masterService.getAdquisicionReactivosList(),
      this._masterService.getContratoElectricidadList(),
      this._masterService.getPagoCombustibleList(),
      this._masterService.getPagoCombustibleVehiculosList(),
      this._masterService.getPagoElectricidadList(),
      this._masterService.getTipoPagoElecOMList(),
      this._masterService.getTitularFangosList(),
      this._masterService.getTitularResiduosDesbasteList(),
      this._masterService.getTitularResiduosNoPeligrososList(),
      this._masterService.getTitularResiduosPeligrososList(),
      this._masterService.getTitularidadEnergiaList(),
      this._masterService.getUbicacionEspanaList(),
    ]).subscribe(([s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12]) => {
      this.adquisicionReactivosList = s1;
      this.contratoElectricidadList = s2;
      this.pagoCombustibleList = s3;
      this.pagoCombustibleVehiculosList = s4;
      this.pagoElectricidadList = s5;
      this.tipoPagoElecOMList = s6;
      this.titularFangosList = s7;
      this.titularResiduosDesbasteList = s8;
      this.titularResiduosNoPeligrososList = s9;
      this.titularResiduosPeligrososList = s10;
      this.titularidadEnergiaList = s11;
      this.ubicacionEspanaList = s12;
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  onSubmit(): boolean {
    if (this.myFormContrato.valid) {
      const formData = this.myFormContrato.value as CebeContratoViewModel;
      this._cebesContractService
        .updateContract(formData)
        .subscribe((result) => {
          this.contract = result;
        });
      this._notificationService.showSuccess(
        this._translateService.instant("messages.savedSuccessfully"),
        null
      );
      return true;
    } else {
      this.markFormGroupTouched(this.myFormContrato);
      this._notificationService.showError(
        `${this._translateService.instant("cebe.generalData.contractData.title") 
          } - ${ 
        this._translateService.instant("messages.validationErrors")}`
      );
      return false;
    }
  }

  triggerFormSubmission(): boolean {
    return this.onSubmit();
  }

  private toggleVisibility(
    selector: string,
    className: string,
    add: boolean
  ): void {
    const elements = this.el.nativeElement.querySelectorAll(selector);
    elements.forEach((element: HTMLElement) => {
      if (add) {
        this.renderer.addClass(element, className);
      } else {
        this.renderer.removeClass(element, className);
      }
    });
  }

  showPM_OM() {
    let someChecked = false;
    const checkedPM = this.myFormContrato.get("puestaMarcha")?.value;
    const checkedOM = this.myFormContrato.get("faseOM")?.value;

    if (checkedPM) {
      someChecked = true;
      this.toggleVisibility(".instFechaPuestaEnMarcha", "hidden", false);
      this.toggleVisibility(".instResponsablePagoPM", "hidden", false);
    } else {
      this.toggleVisibility(".instFechaPuestaEnMarcha", "hidden", true);
      this.toggleVisibility(".instResponsablePagoPM", "hidden", true);
    }

    if (checkedOM) {
      someChecked = true;
      this.toggleVisibility(".instFechaFaseOM", "hidden", false);
      this.toggleVisibility(".instResponsablePagoOM", "hidden", false);
    } else {
      this.toggleVisibility(".instFechaFaseOM", "hidden", true);
      this.toggleVisibility(".instResponsablePagoOM", "hidden", true);
    }

    const actividadId = +this._cebesService.getActividadIDValue();
    const tipoProyectoId = +this._cebesService.getTipoProyectoIDValue();

    if (actividadId === 1 && someChecked) {
      this.toggleVisibility(".instReactivos", "hidden", false);

      if (
        tipoProyectoId === 7 ||
        tipoProyectoId === 8 ||
        tipoProyectoId === 11
      ) {
        this.toggleVisibility(
          ".instTitularidadGestionResiduos",
          "hidden",
          false
        );
        this.toggleVisibility(".instTitularidadGestionLodos", "hidden", false);
      }
    } else if (actividadId === 1 && !someChecked) {
      this.toggleVisibility(".instReactivos", "hidden", true);
      this.toggleVisibility(".instTitularidadGestionResiduos", "hidden", true);
      this.toggleVisibility(".instTitularidadGestionLodos", "hidden", true);
    }
  }

  showContratacionSuministroElectrico() {
    if (
      this.myFormContrato.get("pagoElectricidadID")?.value == 1 ||
      this.myFormContrato.get("pagoElectricidadID")?.value == 2
    ) {
      this.toggleVisibility(
        ".instContratacionSuministroElectrico",
        "hidden",
        false
      );
      return true;
    } else {
      this.toggleVisibility(
        ".instContratacionSuministroElectrico",
        "hidden",
        true
      );
      return false;
    }
  }

  showTipoProyectoFields() {
    this.hideAllFields();
    const actividadId = this._cebesService.getActividadIDValue();
    const tipoProyectoId = this._cebesService.getTipoProyectoIDValue();

    let titularidadExportacionEnergia,
      pagoSuminCombust,
      pagoSuministCombVehic,
      fasePM;
    let faseOM, titGestionResiduos, titGestionLodos, reactivos;
    titularidadExportacionEnergia =
      pagoSuminCombust =
      pagoSuministCombVehic =
      fasePM =
        false;
    faseOM = titGestionResiduos = titGestionLodos = reactivos = false;

    if (actividadId === 1) {
      if (
        tipoProyectoId === 7 ||
        tipoProyectoId === 8 ||
        tipoProyectoId === 9 ||
        tipoProyectoId === 10 ||
        tipoProyectoId === 11
      ) {
        pagoSuminCombust = pagoSuministCombVehic = fasePM = true;
        faseOM = true;
      }
    } else if (actividadId === 2 || actividadId === 3) {
      titularidadExportacionEnergia =
        pagoSuminCombust =
        pagoSuministCombVehic =
          true;
      reactivos = true;
      if (tipoProyectoId !== 3) {
        titGestionResiduos = titGestionLodos = true;
      }
    } else if (actividadId === 4) {
      titularidadExportacionEnergia =
        pagoSuminCombust =
        pagoSuministCombVehic =
          true;
    }

    this.showOperacionDisenoFields(
      titularidadExportacionEnergia,
      pagoSuminCombust,
      pagoSuministCombVehic,
      fasePM,
      faseOM,
      titGestionResiduos,
      titGestionLodos,
      reactivos
    );
  }

  showOperacionDisenoFields(
    titularidadExportacionEnergia: boolean,
    pagoSuminCombust: boolean,
    pagoSuministCombVehic: boolean,
    fasePM: boolean,
    faseOM: boolean,
    titGestionResiduos: boolean,
    titGestionLodos: boolean,
    reactivos: boolean
  ) {
    if (titularidadExportacionEnergia) {
      this.toggleVisibility(
        ".instTitularidadExportacionEnergia",
        "hidden",
        false
      );
    }

    if (pagoSuminCombust) {
      this.toggleVisibility(".instPagoSuministroCombustibles", "hidden", false);
    }

    if (pagoSuministCombVehic) {
      this.toggleVisibility(
        ".instPagoSuministroCombustVehiculos",
        "hidden",
        false
      );
    }

    if (fasePM) {
      this.toggleVisibility(".instcheck-puestaEnMarcha", "hidden", false);
    }

    if (faseOM) {
      this.toggleVisibility(".instcheck-faseOM", "hidden", false);
    }

    if (titGestionResiduos) {
      this.toggleVisibility(".instTitularidadGestionResiduos", "hidden", false);
    }

    if (titGestionLodos) {
      this.toggleVisibility(".instTitularidadGestionLodos", "hidden", false);
    }
    if (reactivos) {
      this.toggleVisibility(".instReactivos", "hidden", false);
    }
  }

  hideAllFields() {
    this.toggleVisibility(
      ".instContratacionSuministroElectrico",
      "hidden",
      true
    );
    this.toggleVisibility(".instTitularidadExportacionEnergia", "hidden", true);
    this.toggleVisibility(".instPagoSuministroCombustibles", "hidden", true);
    this.toggleVisibility(
      ".instPagoSuministroCombustVehiculos",
      "hidden",
      true
    );
    this.toggleVisibility(".instcheck-puestaEnMarcha", "hidden", true);
    this.toggleVisibility(".instFechaPuestaEnMarcha", "hidden", true);
    this.toggleVisibility(".instResponsablePagoPM", "hidden", true);
    this.toggleVisibility(".instcheck-faseOM", "hidden", true);
    this.toggleVisibility(".instFechaFaseOM", "hidden", true);
    this.toggleVisibility(".instResponsablePagoOM", "hidden", true);
    this.toggleVisibility(".instTitularidadGestionResiduos", "hidden", true);
    this.toggleVisibility(".instTitularidadGestionLodos", "hidden", true);
    this.toggleVisibility(".instReactivos", "hidden", true);
  }
}
